import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import GlobalProvider from "../context/GlobalProvider";
import { SDKContext } from "../context/SDKContext";
import { WhiteLabelContext } from "../context/WhiteLabelContext";
import { MuiThemeProvider } from "@material-ui/core";
import { theme } from "./theme";
import "./App.css";
import SDK from "../framework/SDK";
// import cache, { cacheItems } from "../framework/cache";
import whiteLabel from "../framework/whiteLabel";
import config from "../configuration/config";
// import Splash from "../screens/Splash/index.jsx";
import PasswordLogin from "../screens/PasswordLogin";
import Register from "../screens/Register";
import FindHotSpot from "../screens/FindHotSpot/find-hotspot";
import FindHotSpotZip from "../screens/FindHotSpot/find-hotspot-zip";
import DashBoard from "../screens/DashBoard";
import Order from "../screens/Order";
import Redirects from "./Redirects";
import PaymentMethods from "../screens/PaymentMethods";
import Feedback from "../screens/Feedback";
import PrivacyPolicy from "../screens/PrivacyPolicy";
import TermsOfService from "../screens/TermsOfService";
import OrdersDialog from "../screens/OrdersDialog";
import ForgotPasswordInitiate from "../screens/ForgotPasswordInitiate";
import ResetPassword from "../screens/ForgotPasswordInitiate/reset-password";
import ConfirmReset from "../screens/ForgotPasswordInitiate/confirm-password-reset";
import Give from "../screens/Give";
// import Splash from "../screens/Splash";
import ModifyOrder from "../screens/ModifyOrder";

export default function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <WhiteLabelContext.Provider value={{ whiteLabel }}>
        <SDKContext.Provider
          value={{
            sdk: new SDK({
              baseUrl: config.gateway.baseUrl,
            }),
          }}
        >
          <BrowserRouter>
            <GlobalProvider>
              <Switch>
                <Redirect exact from="/" to="login" />
                {/* <Route component={Splash} path={"*"} /> */}
                <Route
                  component={ForgotPasswordInitiate}
                  path={"/reset-password"}
                  exact
                />
                <Route
                  component={ResetPassword}
                  path={"/password-reset/:token"}
                  exact
                />
                <Route
                  component={ConfirmReset}
                  path={"/confirm-password-reset"}
                  exact
                />

                <Route component={Register} path="/register" exact />
                <Route component={PasswordLogin} path="/login" exact />
                <Route component={PrivacyPolicy} path="/privacy-policy" exact />
                <Route
                  component={TermsOfService}
                  path="/terms-of-service"
                  exact
                />
                <Redirects>
                  <Route component={DashBoard} path="/dashboard" exact />
                  <Route component={FindHotSpot} path="/find-hot-spot" exact />
                  <Route
                    component={FindHotSpotZip}
                    path="/find-hot-spot/:zip"
                    exact
                  />
                  <Route component={OrdersDialog} path="/orders" exact />
                  <Route component={Order} path="/orders/:orderUuid" exact />
                  <Route
                    component={ModifyOrder}
                    path="/orders/:orderUuid/modify"
                    exact
                  />
                  <Route component={Feedback} path="/feedback" exact />
                  <Route component={Give} path="/give" exact />
                  <Route
                    component={PaymentMethods}
                    path="/payment-methods"
                    exact
                  />
                </Redirects>
              </Switch>
            </GlobalProvider>
          </BrowserRouter>
        </SDKContext.Provider>
      </WhiteLabelContext.Provider>
    </MuiThemeProvider>
  );
}
